import { setOrderStatus } from "./oms/OMSUtils"
import { ActivityType } from "../constants/AppConstants"
import { ConsultationStatusColor, ConsultationStatusTitle } from "../constants/econsult/EConsultStatus"

export function updateActivityData(activityData) {
    if (activityData['acType'] == ActivityType.order) {
        let orderData = setOrderStatus(activityData)
        // activityData = extendOMSOrderData(orderData)
    } else if (activityData['acType'] == ActivityType.consultation) {
        var consultationStatus = activityData['status']
        activityData['consultationStatus'] = consultationStatus
        activityData['title'] = ConsultationStatusTitle[consultationStatus]
        activityData['statusColor'] = ConsultationStatusColor[consultationStatus]
        activityData['consultationData'] = {
            id: activityData['id'],
            serviceName: activityData['serviceName']
        }
    }
    return activityData
}